<template>
  <div>
    <!-- Show loading screen until account is loaded -->
    <AppLoader v-if="!accountDetail || accountLoader.isLoadingAccount" />
    
    <!-- Only show app when account is successfully loaded -->
    <div v-if="accountDetail && !accountLoader.isLoadingAccount" id="app">
      <Navbar />
      <div id="loading-bar"></div>
      <Breadcrumb />
      <div class="content-wrapper">
        <router-view class="view" />
      </div>
    </div>
    
    <AppFooter 
      :year="versionInfo.year"
      :major-version="versionInfo.majorVersion"
      :minor-version="versionInfo.minorVersion"
      :patch-version="versionInfo.patchVersion"
    />
  </div>
</template>

<script lang="ts">
import { Vue, Component, Watch } from 'vue-property-decorator';
import Navbar from './components/Navbar.vue';
import Breadcrumb from './components/Breadcrumb.vue';
import AppLoader from './components/AppLoader.vue';
import AppFooter from './components/AppFooter.vue';
import { loadVersionInfo, VersionInfo } from './utils/version.util';
import { useAccountLoader, AccountLoader } from './composables/useAccountLoader';

@Component({
  components: { 
    Navbar, 
    Breadcrumb, 
    AppLoader, 
    AppFooter 
  },
})
export default class App extends Vue {
  private versionInfo: VersionInfo = loadVersionInfo();
  private accountLoader: AccountLoader = useAccountLoader(this);

  // Expose properties from the account loader
  get accountDetail() {
    return this.accountLoader.accountDetail;
  }

  get accountDetailError() {
    return this.accountLoader.accountDetailError;
  }

  get accountDetailErrorEventState() {
    return this.accountLoader.accountDetailErrorEventState;
  }

  async mounted(): Promise<void> {
    await this.accountLoader.initializeAccount(this.$route);
  }

  @Watch('accountDetail')
  onAccountDetailChange(newVal: any, oldVal: any) {
    this.accountLoader.onAccountDetailChange(newVal, oldVal);
  }

  @Watch('accountDetailErrorEventState')
  @Watch('accountDetailError')
  async onFailedAccountRetrieve() {
    await this.accountLoader.onFailedAccountRetrieve();
  }
}
</script>

<style lang="scss">
#loading-bar {
  height: 10px;
  position: sticky;
  top: 0%;
  z-index: 30;
}

.content-wrapper {
  margin: 0 6vw;
  display: flex;
  padding: 1.5vh 0;

  .view {
    max-width: 100%;
    width: 100%;
    padding-bottom: 5vh;
  }
}

// b-sidebar
$sidebar-width: 50vw;

.sidebar-content {
  background-color: white !important;
}
// b-sidebar

@import 'jbi-shared/scss/styles.scss';
@import 'assets/styles/sumari_global';
</style>
